import { ACCESS_TOKEN, LMS_ACCESS_TOKEN, REFRESH_TOKEN } from './Constants';

export const persistAuthResult = (
  accessToken: string,
  refreshToken: string,
) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN);
};

export const getLmsToken = (): string | null => {
  return localStorage.getItem(LMS_ACCESS_TOKEN);
};
export const setLmsToken = (token: string) => {
  localStorage.setItem(LMS_ACCESS_TOKEN, token);
};

export const removeSessionInfo = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
};
